import { render, staticRenderFns } from "./CustomerEntity.vue?vue&type=template&id=3bbcc1fa"
import script from "./CustomerEntity.vue?vue&type=script&lang=js"
export * from "./CustomerEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports